class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.addEventListener('keyup', this.onKeyUpEscape.bind(this));

    // Add event listeners for hover
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    this.mainDetailsToggle.setAttribute('open', '');
  }

  onMouseLeave() {
    this.mainDetailsToggle.removeAttribute('open');
  }

  onKeyUpEscape(e) {
    if (e.code.toUpperCase() !== 'ESCAPE') return;

    const openDetails = e.target.closest('details[open]');

    if (!openDetails) return;

    const summaryElement = openDetails.querySelector('summary');

    openDetails.removeAttribute('open');
    summaryElement.focus();
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
